import { render, staticRenderFns } from "./MessageFeedback.vue?vue&type=template&id=56a1305d"
import script from "./MessageFeedback.vue?vue&type=script&lang=js"
export * from "./MessageFeedback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports